<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <!-- <span class="font">控销产品线</span> -->
      <el-form
        ref="formTool"
        :model="formTool"
        :inline="true"
        style="text-align: left"
      >
        <el-form-item prop="name" label="">
          <el-input
            v-model="formTool.name"
            placeholder="请输入产品线名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="clickSearch(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" v-if="permissions.sales_puduct_role_add" @click="addProductLine()">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="center" style="position: relative">
      <MyTable
        :table-data="tableData"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="operation"
        :table-option.sync="tableOption"
        @page-change="getList"
        @handleSelectionChange="handleSelectionChange"
      >
        <template slot="className" slot-scope="scope">
          <el-row v-if="scope.row.productLineGoodsDTO">
            {{ scope.row.productLineGoodsDTO.className }}
          </el-row>
        </template>

        <template slot="image" slot-scope="scope">
          <el-row>
            <el-col :span="8">
              <el-image
                :src="
                  scope.row.productLineGoodsDTO &&
                  scope.row.productLineGoodsDTO.goodsImg
                    ? scope.row.productLineGoodsDTO.goodsImg
                    : avater
                "
                lazy
                style="width: 80px; height: 80px"
              />
            </el-col>
            <el-col :span="16" v-if="scope.row.productLineGoodsDTO">
              <!-- <el-row> {{scope.productLineGoodsDTO.name}} </el-row> -->
              <el-row> {{ scope.row.productLineGoodsDTO.goodsName }} </el-row>
              <el-row>
                {{ scope.row.productLineGoodsDTO.goodsSpecification }}
              </el-row>
              <el-row>
                {{ scope.row.productLineGoodsDTO.goodsFactory }}
              </el-row>
              <el-row>
                {{ scope.row.productLineGoodsDTO.goodsApprovalNumber }}
              </el-row>
            </el-col>
          </el-row>
        </template>

        <template slot="edit" slot-scope="scope">
          <div class="btn-warp">
            <!-- <el-link
              :underline="false"
              type="primary"
              @click="editHandle(scope.row)"
              >编辑</el-link
            > -->
            <el-link
              :underline="false"
              type="primary"
              @click="deleteHandle(scope.row)"
              >删除</el-link
            >
            <el-link
              :underline="false"
              type="primary"
              @click="associationHandle(scope.row)"
              >控销策略</el-link
            >
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              @click="priceHandle(scope.row)"
              >控销定价</el-link
            >
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import { mapGetters } from 'vuex'
import {
  getProductLines,
  soldout,
  getQuantityApi,
  deleteProductLine,
} from "@/api/saleRule/productLine";
import { regionAreaTree } from "@/api/saleRule/saleF";
import avater from "/public/img/default.png";

export default {
  components: { MyTable },
  data() {
    return {
      avater: avater,
      formTool: {
        name: "",
      },
      selectionList: [],
      operation: false,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "产品线名称", prop: "name" },
        { label: "产品线负责人", prop: "managerName" },
        { label: "控销产品", prop: "image", slot: true }, // 这里表示自定义列
        { label: "控销分类", prop: "className", slot: true  },
        { label: "操作", prop: "edit", slot: true,width:'150px',align:'center'  },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getProductLines();
    this.getRegionAreaTree();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    // 控销策略
    associationHandle(row) {
      this.$router.push({
        path: "/salesControlMange/salesControl-strategy-index",
        query: {
          id: row.id || 0,
        },
      });
    },
    // 控销定价
    priceHandle(row) {
      console.log(row, "row");
      this.$router.push({
        path: "/salesControlMange/salesControl-product-price",
        query: {
          isEditor: true,
          productLineId: row.id || null,
          goodsId: row.productLineGoodsDTO?.goodsId || null,
        },
      });
    },
    // 编辑
    editHandle(row) {
      window.sessionStorage.setItem("podurctItem", JSON.stringify(row));
      this.$router.push({
        path: "/salesControlMange/salesControl-product-add",
        query: {
          isEditor: true,
          id: row.id || 0,
        },
      });
    },
    deleteHandle(row) {
      const params = {
        id: row.id,
      };
      deleteProductLine(params).then((res) => {
        this.$message.success("删除成功");
        this.getList()
      });
    },
    //添加产品线
    addProductLine() {
      this.$router.push({
        path: "/salesControlMange/salesControl-product-add",
        query: {},
      });
    },
    // 详情
    delailHandle(row) {
      this.$router.push({
        path: "/productManage/sale-saleDetail",
        query: row,
      });
      console.log(row);
    },
    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList();
    },
    // 切换分页
    getList() {
      this.getProductLines();
    },
    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 查询产品线
    getProductLines(current) {
      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }
      if (this.formTool.name == "") {
        delete this.formTool.name;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size,
        status: 0, //查询非删除的
      };
      getProductLines(params).then((res) => {
        this.tableData = res;
        this.getQuantityApi();
      });
    },
    getQuantityApi() {
      const params = { status: 0 };
      getQuantityApi(params).then((res) => {
        console.log(res);
        this.page.total = parseInt(res);
      });
    },
    // 搜索
    clickSearch(current) {
      this.getProductLines(current);
    },
    // 获取省市区列表
    getRegionAreaTree() {
      let data = {
        level: 3,
      };
      regionAreaTree(data).then((res) => {
        if (+res.code === 0) {
          localStorage.setItem("cityData", JSON.stringify(res.data))
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";
.classification {
  padding: 0px;
  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;
    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }
    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }
  background: white;
  .top {
    display: flex;
    padding: 10px 0 10px 0;
    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .label {
        width: 120px;
      }
      .button {
        margin-right: 20px;
        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;
          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }
          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }
  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);
    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }
  .btn-warp {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-link {
      margin: 5px;
    }
  }
}
</style>
